import { defineStore } from 'pinia'
import { isAbTestParam } from '~/composables/config/ab-test'

const STORAGE_KEY = 'ab_test'

function readStored() {
  const stored = typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem(STORAGE_KEY)
  return isAbTestParam(stored) ? stored : undefined
}

/**
 * The variant the native app opened the webview with, or undefined when the user is not in an A/B test.
 * The query param only exists on the entry URL, so it is kept in sessionStorage for the rest of the session.
 */
export const useAbTestStore = defineStore('ab-test', () => {
  const param = ref(readStored())

  // A param on the URL is a fresh handoff from the app and wins; no or an unknown param keeps what we have.
  function capture(value: unknown) {
    if (!isAbTestParam(value))
      return
    param.value = value
    sessionStorage.setItem(STORAGE_KEY, value)
  }

  return { param: readonly(param), capture }
})
